// extracted by mini-css-extract-plugin
export default {"Blueberry":"#3E3AC2","Bluecheese":"#615CFF","sizeXL":"20px","sizeMD":"16px","body":"Gf4f938","firstButton":"Gf64840","modalTitle":"Ge80a99","modalBodyText":"G580d90"};